module.exports = __webpack_public_path__ + "img/home-org.fa9c92cf.png";